import React from 'react';
import PropTypes from 'prop-types';
import css from './IntakeElementsContainer.scss';
import QuestionPanel from './QuestionPanel';
import { StudentIntakeElementKind } from './studentIntakeTypes';
import { IntakeElement } from '../utils/types';

function IntakeElementsContainer(props) {

  const getSectionHeader = (intakeElement, index) => (
    <div key={index}>
      <h1 className={css['section-header']} key={index}>{intakeElement.text}</h1>
    </div>
  );

  const getSectionInstruction = (intakeElement, index) => {
    return (<p className={css['section-instruction']} key={index}>{intakeElement.text}</p>)
  };
  
  const getQuestionNumber = intakeElement => {
    return props.intakeElements
      .filter(element => element.kind === StudentIntakeElementKind.question && !element.retired)
      .map(element => element.questionId)
      .indexOf(intakeElement.questionId)
      + 1;
  };

  const getQuestionPanel = (intakeElement, index) => {
    return (
      <QuestionPanel
        intakeElement={intakeElement}
        setValue={props.setValue}
        isReadOnly={props.isReadOnly}
        questionNumber={getQuestionNumber(intakeElement)}
        key={index}
      />
    )
  };

  const getFormComponent = (intakeElement, index) => {
    if (intakeElement.retired) return null;
    if ([StudentIntakeElementKind.header, StudentIntakeElementKind.head].includes(intakeElement.kind)) {
      return getSectionHeader(intakeElement, index)
    } else if ([StudentIntakeElementKind.instruction, StudentIntakeElementKind.text].includes(intakeElement.kind)) {
      return getSectionInstruction(intakeElement, index)
    } else if (intakeElement.kind === StudentIntakeElementKind.question) {
      return getQuestionPanel(intakeElement, index)
    }
  };

  return (
    <div className={css['questions-section-container']}>
      {props.intakeElements.map(getFormComponent)}
    </div>
  )
}

IntakeElementsContainer.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  intakeElements: PropTypes.arrayOf(IntakeElement),
  setValue: PropTypes.func.isRequired
};

export default IntakeElementsContainer;
